module.exports = __webpack_public_path__ + "static/img/100869.72c0830b.png";